module.exports = __webpack_public_path__ + "static/Wren-57410883e8fe03b15c64bc7a7d5b691f.jpg";